export const GET_JOB_SITES = "GET_JOB_SITES"
export const GET_JOB_SITES_SUCCESS = "GET_JOB_SITES_SUCCESS"
export const GET_JOB_SITES_FAILURE = "GET_JOB_SITES_FAILURE"
export const SET_LANGUAGE = "SET_LANGUAGE";
export const INITIALIZE_LANGUAGE = "INITIALIZE_LANGUAGE"


export const SIGNATURE = "SIGNATURE"
export const SIGNATURE_SUCCESS = "SIGNATURE_SUCCESS"
export const SIGNATURE_FAILURE = "SIGNATURE_FAILURE"

export const GET_VIDEO = "GET_VIDEO"
export const GET_VIDEO_SUCCESS = "GET_VIDEO_SUCCESS"
export const GET_VIDEO_FAILURE = "GET_VIDEO_FAILURE"

export const SIGNATURE_STATUS = "SIGNATURE_STATUS"
export const SIGNATURE_STATUS_SUCCESS = "SIGNATURE_STATUS_SUCCESS"
export const SIGNATURE_STATUS_FAILURE = "SIGNATURE_STATUS_FAILURE"

export const RESET_TRAINING_VIDEO = "RESET_TRAINING_VIDEO"
